export const getCurrentReviewedMonthYear = () => new Intl.DateTimeFormat("en-US", {
  month: "long",
  year: "numeric",
}).format(new Date());

export const getReviewedLabel = (prefix = "Reviewed") => `${prefix} ${getCurrentReviewedMonthYear()}`;

export const formatReviewedMonth = () => getReviewedLabel();

export const getCountryTrustSignal = (country) => {
  const reviewLabel = formatReviewedMonth(country?.last_reviewed);
  const confidenceLevel = country?.confidence_level;
  const volatilityStatus = country?.volatility_status;

  if (volatilityStatus === "Watch" || volatilityStatus === "Changing") {
    return {
      label: `${reviewLabel} • Policy watch`,
      warning: "Recent policy or regulatory changes may affect this recommendation.",
    };
  }

  if (confidenceLevel === "Low") {
    return {
      label: `${reviewLabel} • Low confidence`,
      warning: "Some assumptions for this country are still being refined.",
    };
  }

  return {
    label: reviewLabel,
    warning: null,
  };
};